import { CampaignType, Platform } from '@round/api';
import React, { useState } from 'react';
import { useClientBookingData } from '../../useClientBookingData';
import BookingSummary from '../../components/BookingSummary/BookingSummary';
import styles from './BookingDetailsDropdown.module.css';
import { ReactComponent as DropdownArrowIcon } from '../../../../../assets/Chevron.svg';
import { ReactComponent as RemoveIcon } from '../../../../../assets/Close.svg';
import cn from 'classnames';
import BookingCartItemRow, { BookingCartItemRowProps } from '../../components/BookingCartItemRow/BookingCartItemRow';
import { Button } from '@round/ui-kit';

type BookingDetailsDropdownProps = {
    influencerBookings: {
        tiktok: number[];
        instagram: number[];
    };
    selectedCurrency: number | undefined;
    campaignType: CampaignType;
    removeBooking: (platform: Platform, id: number | undefined) => void;
    createBooking: () => void;
};

export type BookingDetailsListRow = Omit<BookingCartItemRowProps, 'cost'> & {
    influencerId: number | undefined;
    cost: number | null;
};

const BookingDetailsDropdown = ({
    influencerBookings,
    selectedCurrency,
    campaignType,
    removeBooking,
    createBooking,
}: BookingDetailsDropdownProps) => {
    const { bookingCartItems, influencerImages, selectedPlatforms, totalCost, totalCreators, influencersInitialized } =
        useClientBookingData(
            { tiktok: influencerBookings.tiktok, instagram: influencerBookings.instagram },
            selectedCurrency,
            campaignType
        );

    const [isListOpen, setIsListOpen] = useState(false);

    return (
        <>
            <div className={styles.detailsBarWrapper} onClick={() => setIsListOpen((prev) => !prev)}>
                <BookingSummary
                    totalCost={totalCost}
                    totalCreators={totalCreators}
                    platforms={selectedPlatforms}
                    loading={!influencersInitialized}
                    currencyId={selectedCurrency}
                />
                <div className={styles.dropdownIconContainer}>
                    <DropdownArrowIcon className={cn({ [styles.rotated]: isListOpen })} />
                </div>
            </div>
            <div className={cn(styles.dropdown, { [styles.isOpen]: isListOpen })}>
                <div className={styles.bookingList}>
                    {!bookingCartItems.length && <div className={styles.emptyNote}>No posts added yet</div>}
                    {bookingCartItems.map((row) => (
                        <div className={styles.listItemWrapper}>
                            <BookingCartItemRow
                                cartItem={row}
                                influencerImage={influencerImages.find(
                                    (image) => image.influencerId === row.influencerId
                                )}
                                currencyId={selectedCurrency}
                                readOnly
                            />
                            <RemoveIcon
                                className={styles.removeIcon}
                                onClick={() => {
                                    if (!row.influencerId) {
                                        return;
                                    }
                                    removeBooking(row.platform, row.influencerId);
                                }}
                            />
                        </div>
                    ))}
                </div>
            </div>
            {!!bookingCartItems.length && isListOpen && (
                <Button className={styles.createBookingButton} type="filled" color="black" onClick={createBooking}>
                    Create Booking
                </Button>
            )}
        </>
    );
};

export default BookingDetailsDropdown;
